import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appPhoneMask]',
    standalone: true
})
export class PhoneMaskDirective {
    constructor(private ngControl: NgControl) {}

    @HostListener('input', ['$event.target.value'])
    onInput(value: string): void {
        const cleaned = value.replace(/\D/g, ''); // Remove non-digits
        let formatted = '';

        if (cleaned.length > 0) {
            formatted = `(${cleaned.substring(0, 3)}`;
            if (cleaned.length >= 4) {
                formatted += `) ${cleaned.substring(3, 6)}`;
            }
            if (cleaned.length >= 7) {
                formatted += `-${cleaned.substring(6, 10)}`;
            }
        }

        this.ngControl.control?.setValue(formatted, { emitEvent: false });
    }
}